import { isDevMode } from "@cayo/shared/utils/isDevMode";
import { urlUtils } from "@cayo/shared/utils/url";
import { clearAuthData } from "../utils/clearAuthData";

const logoutUrl = "account/logout";
const normalizedLogoutUrl = isDevMode ? urlUtils.addPublicUrl(logoutUrl) : logoutUrl;

export const logout = () => {
  clearAuthData();

  window.location.assign(normalizedLogoutUrl);
};
